export default __webpack_public_path__ + "static/media/_empty_interest.4c569e59.svg";